/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfDesignLogoUploadDto } from "../models/AjaxResponseOfDesignLogoUploadDto";
import type { AjaxResponseOfOperationalDesignDto } from "../models/AjaxResponseOfOperationalDesignDto";
import type { AjaxResponseOfListOfStoreInventoryOptionDto } from "../models/AjaxResponseOfListOfStoreInventoryOptionDto";
import type { DesignLogoUploadInput } from "../models/DesignLogoUploadInput";
import type { OperationalDesignInput } from "../models/OperationalDesignInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalDesignAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfOperationalDesignDto Success
   * @throws ApiError
   */
  public get({
    workspaceId,
  }: {
    workspaceId: number;
  }): CancelablePromise<AjaxResponseOfOperationalDesignDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/workspaces/{workspaceId}/design",
      path: {
        workspaceId: workspaceId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfStoreInventoryOptionDto Success
   * @throws ApiError
   */
  public getInventories({
    workspaceId,
  }: {
    workspaceId: number;
  }): CancelablePromise<AjaxResponseOfListOfStoreInventoryOptionDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/workspaces/{workspaceId}/design/inventories",
      path: {
        workspaceId: workspaceId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalDesignDto Success
   * @throws ApiError
   */
  public update({
    workspaceId,
    requestBody,
  }: {
    workspaceId: number;
    requestBody?: OperationalDesignInput;
  }): CancelablePromise<AjaxResponseOfOperationalDesignDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/workspaces/{workspaceId}/design",
      path: {
        workspaceId: workspaceId,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfDesignLogoUploadDto Success
   * @throws ApiError
   */
  public createLogoUpload({
    workspaceId,
    requestBody,
  }: {
    workspaceId: number;
    requestBody?: DesignLogoUploadInput;
  }): CancelablePromise<AjaxResponseOfDesignLogoUploadDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/workspaces/{workspaceId}/design/logo-upload",
      path: {
        workspaceId: workspaceId,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
